import {applyMiddleware, compose, createStore} from 'redux'
import {batchStoreEnhancer, batchMiddleware} from 'redux-batch-enhancer'
import thunk from 'redux-thunk'
import rootReducer from './rootReducer'
import {routerMiddleware} from 'react-router-redux'
import api from './middleware/api'
import routerQueryParameters from './middleware/routerQueryParameters'
import error from './middleware/error'
import stateSaver from './middleware/stateSaver'
import requestsBuffer from './middleware/requestsBuffer'

export default function configureStore(initialState = {}, history) {
  const middlewares = [
    batchMiddleware,
    thunk,
    routerQueryParameters,
    routerMiddleware(history),
    requestsBuffer,
    api,
    error,
    stateSaver
  ]
  // Compose final middleware and use devtools in debug environment
  let middleware = applyMiddleware(...middlewares)

  if (__DEBUG__) {
    const devTools = window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()

    if (devTools) {
      middleware = compose(middleware, devTools)
    }
  }

  // Create final store and subscribe router in debug env ie. for devtools
  middleware = compose(middleware, batchStoreEnhancer)
  const store = middleware(createStore)(rootReducer, initialState)

  if (module.hot) {
    module.hot.accept('./rootReducer', () => {
      const nextRootReducer = require('./rootReducer').default

      store.replaceReducer(nextRootReducer)
    })
  }
  return store
}



// WEBPACK FOOTER //
// ./client/redux/configureStore.js